import React, { Component } from 'react';
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";

class LatestLivestream extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div className="justify-center">
          <video
            onClick={()=> {
              loggingUtils.logEvent(
                this.props.address != null
                  ? this.props.address
                  : encryptUtils.getWalletUnconnectedUserId(),
                "home",
                "home_click_latest_livestream",
                "info",
                "https://the402.xyz",
                {}
              );
              window.open(window.location.origin + this.props.itemRoute, "_self")
            }}
            className="h-112 mt-4 w-full object-cover cursor-pointer bg-black rounded-none sm:rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.4)]"
            src={this.props.video}
            loop autoplay="autoplay" controls muted
          >
          </video>
          <div className="flex mt-0 md:py-0 py-4 md:mt-2">
            <div className="rounded-full">
              <img className="rounded-full ml-2 mt-0 md:mt-8 lg:mt-4 lg:ml-8 w-10 h-10 lg:w-12 lg:h-12" src={this.props.creatorImage} />
            </div>
            <div className="ml-8 mt-0 lg:mt-4">
              <div className="dark:text-white text-gray-800 text-lg lg:text-xl font-semibold cursor-pointer">
                {this.props.creatorName}
              </div>
              <div className="dark:text-zinc-400 text-zinc-600 mt-2 sm:mt-1 text-black text-sm lg:text-md font-semibold cursor-pointer">
                {this.props.itemName}
              </div>
            </div>
            <div>
              {
                this.props.address != null &&
                this.props.creatorAddress.toLowerCase() in this.props.subscriberStatuses &&
                this.props.address.toLowerCase() in this.props.subscriberStatuses[this.props.creatorAddress.toLowerCase()]
                  ?
                <div className="ml-2 lg:ml-8 mt-0 lg:mt-4 cursor-pointer hover:-translate-y-0 hover:scale-105 duration-500 ml-4 w-24 sm:w-28 h-8 flex justify-center items-center text-sm sm:text-sm text-gray-300 dark:text-gray-400 font-bold bg-zinc-600 dark:bg-zinc-800 rounded-lg">
                  Subscribed
                </div>
                  :
                <div
                  className="ml-2 lg:ml-8 mt-0 lg:mt-4 cursor-pointer hover:-translate-y-0 hover:scale-105 duration-500 ml-4 w-20 lg:w-28 h-8 flex justify-center items-center text-sm sm:text-sm font-bold bg-blue-600 rounded-lg text-white"
                  onClick={() => {
                    loggingUtils.logEvent(
                      this.props.address != null
                        ? this.props.address
                        : encryptUtils.getWalletUnconnectedUserId(),
                      "home",
                      "home_subscribe_latest_livestream",
                      "info",
                      "https://the402.xyz",
                      {}
                    );
                    this.props.selectItemForSubscribe({"creatorAddress": this.props.creatorAddress});
                  }}
                >
                  Subscribe
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LatestLivestream;
